import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getFamilyFestFaqCategories = () => vdkEmHappinessPortalApi.get('family-fest/faq-categories/get-all');
// Registration-side or event-page categories only (filtered by the backend).
const getFamilyFestFaqCategoriesByType = (request) => vdkEmHappinessPortalApi.post('family-fest/faq-categories/get-by-type', request);
const getFamilyFestFaqCategoryById = (request) => vdkEmHappinessPortalApi.get(`family-fest/faq-categories/by-id/${request.id}`);
const createFamilyFestFaqCategory = (request) => vdkEmHappinessPortalApi.post('family-fest/faq-categories/create', request);
const updateFamilyFestFaqCategory = (request) => vdkEmHappinessPortalApi.put('family-fest/faq-categories/update', request);
const deleteFamilyFestFaqCategory = (request) => vdkEmHappinessPortalApi.delete(`family-fest/faq-categories/delete/${request.id}`);
const reorderFamilyFestFaqCategories = (request) => vdkEmHappinessPortalApi.post('family-fest/faq-categories/reorder', request);
const familyFestFaqCategoryApi = {
    getFamilyFestFaqCategories,
    getFamilyFestFaqCategoriesByType,
    getFamilyFestFaqCategoryById,
    createFamilyFestFaqCategory,
    updateFamilyFestFaqCategory,
    deleteFamilyFestFaqCategory,
    reorderFamilyFestFaqCategories
};
export default familyFestFaqCategoryApi;
